import { LenderConcession } from '../../interfaces';

export const WellsFargo: LenderConcession = {
  lenderNameRegEx: new RegExp('WELLS|^WF.*|WLLSFRGO'),
  standardMinimumPercent: 1.75,
  minimumDollarAmount: 15,
  apr: 1.0,
};
